import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { FormsModule } from '@angular/forms';
import { CallbackComponent } from './callback/callback.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { AlphaOnlyDirective } from './alpha-only.directive';
import { NumericDirectiveDirective } from './numeric-directive.directive';
import { HttpClientModule } from '@angular/common/http';
import { OtpDirective } from './otp.directive';
import { EmailMobileDirective } from './email-mobile.directive';
import { LogoutComponent } from './logout/logout.component';
import { BlockCopyPasteDirective } from './block-copy-paste.directive';


@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    CallbackComponent,
    SignInComponent,
    AlphaOnlyDirective,
    NumericDirectiveDirective,
    OtpDirective,
    EmailMobileDirective,
    LogoutComponent,
    BlockCopyPasteDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
